
$(document).on('click', '.custom_pricing_link', function (e) {
  e.preventDefault();
  if ($('#custom-pricing details').prop('open')) {
  } else {
    $('#custom-pricing details h2').click();
  }  
  
  $('html, body').animate({
    scrollTop: $('#custom-pricing').offset().top
  }, 600);
});
 
$(document).on('click', '.buld-order', function () {
  $('.buld-order').addClass('active');
  $('.order').removeClass('active');
  $('#add-to-cart-btn-custom').show();
  $('.product-form__submit').hide();
  $('.product-form__input--pill').addClass('bulk-mode');
  $('a.more-unit').show();
  call_buld_order();
});

$(document).on('click', '.order', function () {
  $('.buld-order').removeClass('active');
  $('.order').addClass('active');
  $('#add-to-cart-btn-custom').hide();
  $('.product-form__submit').show();
  $('.product-form__input--pill').removeClass('bulk-mode');
  $('a.more-unit').hide();
  call_buld_order();
});  
  
// document.addEventListener('DOMContentLoaded', function () {
//     const bulkBtn = document.querySelector('.buld-order');
//     const orderBtn = document.querySelector('.order');
//     const bulkAddToCart = document.querySelector('#add-to-cart-btn-custom');
//     const defaultAddToCart = document.querySelector('.product-form__submit');
//     const swatchFieldset = document.querySelector('.product-form__input--pill');

//     if (bulkBtn && orderBtn && swatchFieldset) {
//       bulkBtn.addEventListener('click', function () {
//         bulkBtn.classList.add('active');
//         orderBtn.classList.remove('active');
//         swatchFieldset.classList.add('bulk-mode');
//         bulkAddToCart.style.display = 'block';
//         defaultAddToCart.style.display = 'none';
//       });

//       orderBtn.addEventListener('click', function () {
//         bulkBtn.classList.remove('active');
//         orderBtn.classList.add('active');
//         swatchFieldset.classList.remove('bulk-mode');
//         bulkAddToCart.style.display = 'none';
//         defaultAddToCart.style.display = 'block';
//       });
//     }
// });

  
// document.addEventListener('DOMContentLoaded', function () {
//     document.querySelectorAll('.qty-wrapper').forEach(function (wrapper) {
//       const input = wrapper.querySelector('.qty-input');
//       const plus = wrapper.querySelector('.qty-plus');
//       const minus = wrapper.querySelector('.qty-minus');

//       plus.addEventListener('click', function () {
//         const max = parseInt(input.getAttribute('max')) || Infinity;
//         let value = parseInt(input.value) || 0;
//         if (value < max) input.value = value + 1;
//       });

//       minus.addEventListener('click', function () {
//         let value = parseInt(input.value) || 0;
//         if (value > 0) input.value = value - 1;
//       });
//     });
// });
  
// document.getElementById('add-to-cart-btn-custom').addEventListener('click', function(e) {
//   e.preventDefault();
//   console.log('Add to cart clicked');

//   // Get selected color
//   const selectedColorRadio = document.querySelector('input[name^="Color-1"]:checked');
//   const selectedColor = selectedColorRadio ? selectedColorRadio.value : null;

//   // if (!selectedColor) {
//   //   alert("Please select a color.");
//   //   return;
//   // }

//   const sizeOptions = document.querySelectorAll('.size-option');
//   let delay = 0;

//   sizeOptions.forEach((option, index) => {
//     const radio = option.querySelector('input[type="radio"]');
//     const size = radio?.value;
//     const variantId = radio?.dataset.variantId;
//     const quantityInput = option.querySelector('input.qty-input');
//     console.log(variantId)
//     const quantity = parseInt(quantityInput.value);

//     if (quantity > 0 && variantId) {
//       setTimeout(() => {
//         fetch('/cart/add.js', {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json'
//           },
//           body: JSON.stringify({
//             id: variantId,
//             quantity: quantity
//           })
//         })
//         .then(response => response.json())
//         .then(data => {
//           console.log(`✅ Added ${quantity} x ${selectedColor} / ${size}`);
//         })
//         .catch(error => {
//           console.error(`❌ Error adding ${selectedColor} / ${size}:`, error);
//         });
//       }, delay);
      
//       delay += 1000; // Add 300ms between each request
//     }
//   });
// });
// Quantity button logic
call_buld_order();
function call_buld_order() {  
  $('.qty-wrapper').each(function () {
    
    const $input = $(this).find('.qty-input');
    const $plus = $(this).find('.qty-plus');
    const $minus = $(this).find('.qty-minus');

    $plus.off('click').on('click', function () {
      $('.qty-error-mgs-blank').hide();  
      const max = parseInt($input.attr('max')) || Infinity;
      let value = parseInt($input.val()) || 0;
      if (value < max) $input.val(value + 1);
    });

    $minus.off('click').on('click', function () {
      let value = parseInt($input.val()) || 0;
      if (value > 0) $input.val(value - 1);
    });
  });

  $('#add-to-cart-btn-custom').off('click').on('click', function (e) {
    e.preventDefault();
   // console.log('Add to cart clicked');
    var minimum_quantity_bulk = $('.minimum_quantity_bulk').val(); // Ensure it's a number
//    alert(minimum_quantity_bulk);  // For debugging
    if (minimum_quantity_bulk > 0) { // Check if the minimum quantity is valid
        let totalQuantity = 0;

        // Loop through the quantity inputs and calculate the total quantity
        $('.qty-input').each(function() {
            let qty = parseInt($(this).val()) || 0; // parse integer or 0 if not a number
            totalQuantity += qty;
        });

        // Log the total quantity
        console.log('Total Quantity:', totalQuantity);

        // Check if the total quantity is less than the minimum required
        if (totalQuantity >= minimum_quantity_bulk) {
          $('.qty-error-mgs').hide();
            // Proceed with whatever needs to happen when the quantity is valid
        } else {
            $('.qty-error-mgs').show();
            //alert(minimum_quantity_bulk);  // Show the minimum required quantity
            //alert(totalQuantity);  // Show the total quantity added
           // alert('You have added less quantity than the minimum required.');  // Corrected message
            return false; // Prevent further action (e.g., form submission)
        }
    } else {
        let totalQuantity = 0;

        // Loop through the quantity inputs and calculate the total quantity
        $('.qty-input').each(function() {
            let qty = parseInt($(this).val()) || 0; // parse integer or 0 if not a number
            totalQuantity += qty;
        });
        if(totalQuantity == 0 && totalQuantity == ''){
            $('.qty-error-mgs-blank').show();
            return false;
        }else {
            $('.qty-error-mgs-blank').hide();
        }    
    }

  const selectedColor = $('input[name^="Color-1"]:checked').val() || null;
  let delay = 0;
  const addToCartPromises = [];

  $('.size-option').each(function () {
    const $option = $(this);
    const $radio = $option.find('input[type="radio"]');
    const size = $radio.val();
    const variantId = $radio.data('variant-id');
    console.log(variantId);
    const quantity = parseInt($option.find('input.qty-input').val());

if (quantity > 0 && variantId) {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      })
      .then(response => response.json())
      .then(data => {
  fetch('/?section_id=cart-drawer')
    .then(res => res.text())
    .then(html => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newDrawer = doc.querySelector('cart-drawer');

      const existingDrawer = document.querySelector('cart-drawer');
      if (existingDrawer && newDrawer) {
        existingDrawer.innerHTML = newDrawer.innerHTML;

        existingDrawer.classList.add('active');

        document.body.classList.add('overflow-hidden');
      }
      updateCartCount();
    });

  resolve();
})

      .catch(error => {
        console.error(`❌ Error adding ${selectedColor} / ${size}:`, error);
        reject(error);
      });
    }, delay);
  });

  addToCartPromises.push(promise);
  delay += 1000;
}


  });

  // When all items have been added, open the cart drawer
  Promise.all(addToCartPromises)
    .then(() => {
      console.log('🛒 All products added to cart. Opening drawer...');
      // window.location.href = '/cart';
     openCartDrawer();
      updateCartCount();
    })
    .catch(err => {
      console.warn('Some items failed to add to the cart.');
    });
});

}

function openCartDrawer() {
  fetch(`${routes.cart_url}?section_id=cart-drawer`)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const selectors = ['#cart-drawer-items', '.cart-drawer__footer'];

      selectors.forEach((selector) => {
        const target = document.querySelector(selector);
        const source = html.querySelector(selector);
        if (target && source) {
          target.replaceWith(source);
        }
      });

      updateCartCount();

      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) cartDrawer.classList.remove('is-empty');

      const emptyDrawer = document.querySelector('.drawer__inner-empty');
      if (emptyDrawer) emptyDrawer.style.display = 'none';

      const checkoutBtn = document.getElementById('CartDrawer-Checkout');
      if (checkoutBtn) checkoutBtn.removeAttribute('disabled');

      // Simulate opening the cart drawer
      const cartIconTrigger = document.querySelector('a#cart-icon-bubble');
      if (cartIconTrigger) cartIconTrigger.click();
      updateCartCount();

    })
    .catch((e) => console.error('Error opening cart drawer:', e));
}
function updateCartCount() {
    fetch('/cart.js')
    .then((response) => response.json())
    .then((data) => {
        const cartCountBubble = document.querySelector('.cart-count-bubble span[aria-hidden="true"]');
        const visuallyHiddenCartCount = document.querySelector('.cart-count-bubble .visually-hidden');

        if (cartCountBubble) cartCountBubble.textContent = data.item_count;
        if (visuallyHiddenCartCount) visuallyHiddenCartCount.textContent = `${data.item_count} items`;
    })
    .catch((error) => console.error('Error updating cart count:', error));
}
$( document ).ready(function() {
    call_buld_order();
    console.log( "ready!" );
    $(document).on('click', '.bulk-order-main-wrap variant-radios fieldset.js.product-form__input:nth-child(2)', function () {
      setTimeout(function() {
      location.reload();
      }, 500);
    });

    //Easift Option
    setTimeout(function() {
      $('.tpo_radio-button-wrapper.below_value label.tpo_undefined.tpo_image_shape_square .tpo_radio-button').addClass('tpo_checked');
      $('.tpo_radio-button-wrapper.below_value label.tpo_undefined.tpo_image_shape_square').trigger('click');
      $('.tpo_radio-button-wrapper.below_value label.tpo_undefined.tpo_image_shape_square input').prop('checked', true);
    }, 4000);
});

